import React from 'react';
import { Phone, MessageCircle, CheckCircle2 } from 'lucide-react';
import { detailedServices, company, waLink } from '../mock';
import useReveal from '../hooks/useReveal';

function Row({ item }) {
  const { ref, inView } = useReveal();
  return (
    <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} grid lg:grid-cols-2 gap-10 items-center`}>
      <div className={item.reverse ? 'lg:order-2' : ''}>
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img src={item.image} alt={item.title} className="w-full h-[320px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B2447]/50 to-transparent" />
        </div>
      </div>
      <div className={item.reverse ? 'lg:order-1' : ''}>
        <h3 className="text-2xl lg:text-3xl font-extrabold text-slate-900 font-display leading-tight">{item.title}</h3>
        <p className="mt-4 text-slate-600 leading-relaxed">{item.body}</p>
        <div className="mt-5 flex flex-wrap gap-3">
          {['Documentation', 'Testing Coordination', 'Approval Support'].map((t) => (
            <span key={t} className="inline-flex items-center gap-1.5 text-sm text-slate-700 bg-slate-100 rounded-full px-3 py-1.5">
              <CheckCircle2 className="w-4 h-4 text-primary" /> {t}
            </span>
          ))}
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <a href={`tel:${company.phoneRaw}`} className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-semibold rounded-full px-6 h-12 transition-colors">
            <Phone className="w-4 h-4" /> Get Started
          </a>
          <a href={waLink(`Hi Lockene, I have an enquiry regarding: ${item.title}`)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 border-2 border-slate-200 hover:border-primary text-slate-700 font-semibold rounded-full px-6 h-12 transition-colors">
            <MessageCircle className="w-4 h-4" /> Enquire
          </a>
        </div>
      </div>
    </div>
  );
}

export default function ServiceDetails() {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 space-y-20">
        {detailedServices.map((item) => (
          <Row key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}
